var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent, Children, cloneElement, isValidElement } from "react";
import { DateRangePicker, DatePreset, getStartAndEndDatesForPreset } from "@irati/ui/src/temp/DateRangePicker";
var DateRangeWrapper = /** @class */ (function (_super) {
    __extends(DateRangeWrapper, _super);
    function DateRangeWrapper(props) {
        var _this = _super.call(this, props) || this;
        var preset = DatePreset.LAST_TWELVE_MONTHS;
        var _a = getStartAndEndDatesForPreset(preset), startDate = _a[0], endDate = _a[1];
        _this.state = {
            preset: preset,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
        };
        return _this;
    }
    DateRangeWrapper.prototype.onDateRangeChange = function (_a) {
        var startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
        var fetch = this.props.fetch;
        if (!startDate || !endDate)
            return;
        var start = startDate.toISOString();
        var end = endDate.toISOString();
        this.setState({
            startDate: start,
            endDate: end,
            preset: preset
        }, function () {
            fetch(start, end);
        });
    };
    DateRangeWrapper.prototype.componentDidMount = function () {
        var fetch = this.props.fetch;
        var _a = this.state, startDate = _a.startDate, endDate = _a.endDate;
        fetch(startDate, endDate);
    };
    DateRangeWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.state, stringStartDate = _a.startDate, stringEndDate = _a.endDate, preset = _a.preset;
        var _b = this.props, showDatePicker = _b.showDatePicker, children = _b.children;
        var startDate = new Date(stringStartDate);
        var endDate = new Date(stringEndDate);
        var wrappedChildren = Children.map(children, function (child) {
            return isValidElement(child)
                ? cloneElement(child, {
                    startDate: startDate,
                    endDate: endDate,
                    preset: preset,
                    onDateSelect: _this.onDateRangeChange.bind(_this)
                })
                : child;
        });
        return (React.createElement(React.Fragment, null,
            wrappedChildren,
            showDatePicker && React.createElement(DateRangePicker, { onSave: this.onDateRangeChange, startDate: startDate, endDate: endDate, preset: preset })));
    };
    DateRangeWrapper.defaultProps = {
        showDatePicker: false
    };
    return DateRangeWrapper;
}(PureComponent));
export default DateRangeWrapper;
